import React from 'react';
import {observer, inject} from 'mobx-react';
import {List, Modal, Button, Spin} from '@enos/dpl';
import {withRouter} from 'react-router-dom';
import localeText from '@locale';
import {querystring} from '~/utils/tools';
import {DesktopOrTablet, Mobile} from '../Responsive';
import store from './store';
import MobileNavBack from '~/components/MobileNavBack';
import {isInitPassword} from '~/components/ChangeCipher/Init';
import Item from './Item';

import './index.less';
import './mobile.less';

@inject((stores, props) => {
  const {sessionStore} = stores;
  return {
    ...props,
    sessionStore,
    uiStore: store
  };
})
@withRouter
@observer
class CompanySwitchList extends React.Component {
  sessionSet = false;

  static defaultProps = {
    prefixClass: 'component-ou-switch-list',
    closable: true
  };

  componentDidMount() {
    this.sessionSet = false;
    const {sessionStore, isFromLogin, uiStore} = this.props;
    if (!isFromLogin) {
      sessionStore.getOrganizations();
      uiStore.setCheckedId(sessionStore.workingOrganization.id);
    }
  }

  componentDidUpdate() {
    const {sessionStore, isFromLogin} = this.props;
    const {isDoingMFA, organizations} = sessionStore;
    if (isDoingMFA !== undefined && !isDoingMFA && isFromLogin && organizations && organizations.length === 1 && !this.sessionSet) {
      this.sessionSet = true;
      this.selectOUSuccessfully(sessionStore.organizations[0].id);
    }
  }


  selectOUSuccessfully = (id) => {
    const {history, sessionStore, uiStore, isFromLogin} = this.props;
    uiStore.setCheckedId(id);
    if (sessionStore.workingOrganization.id === id && !isFromLogin) {
      return;
    }
    sessionStore.setSession(id).then((data) => {
      if (!data) {
        return;
      }

      const redirect = querystring('redirect');
      if (!isFromLogin) {
        window.location.replace('/');
      } else if (
        redirect === ''
        || redirect === null
        || redirect.match(/\/404($|\?|#)/)
      ) {
        history.push('/');
        isInitPassword();
      } else {
        history.push(redirect);
      }
      uiStore.toggleCompanySwitchModal(false);
    });
  };

  render() {
    const {
      sessionStore,
      prefixClass,
      header,
      uiStore,
      closable,
      isFromLogin
    } = this.props;
    return (
      <Modal
        maskClosable={false}
        wrapClassName='switch-company vertical-center-modal'
        visible={uiStore.showCompanySwitchModal}
        closable={closable}
        footer={null}
        destroyOnClose
        onCancel={() => uiStore.toggleCompanySwitchModal(false)}
        bodyStyle={!sessionStore.isMobile ? {maxHeight: '400px', overflowY: 'auto'} : {height: '100%', overflowY: 'auto'}}
      >
        <Spin spinning={sessionStore.pageLoading}>
          <div className={prefixClass}>
            <DesktopOrTablet>
              <h3 className='list-header'>
                {header || localeText('COMMON.TITLE_SWITCH_OU')}
              </h3>
              <List
                className='company-list'
                dataSource={sessionStore.organizations.slice()}
                renderItem={item => (
                  <Item
                    item={item}
                    showCurrent={!isFromLogin}
                    selectOUSuccessfully={this.selectOUSuccessfully}
                  />
                )}
              />
            </DesktopOrTablet>
            <Mobile>
              <MobileNavBack
                title={localeText('COMMON.TITLE_SELECT_ORGANIZATION')}
                onBack={() => uiStore.toggleCompanySwitchModal(false)}
              />
              <div className='company-switch-content'>
                <List
                  className='company-list'
                  dataSource={sessionStore.organizations.slice()}
                  renderItem={item => (
                    <Item
                      item={item}
                      showCurrent={!isFromLogin}
                      selectOUSuccessfully={this.selectOUSuccessfully}
                    />
                  )}
                />
                <Button
                  className='btn-company-switch'
                  type='primary'
                  disabled={uiStore.checkedId === ''}
                  onClick={() => this.selectOUSuccessfully(uiStore.checkedId)}
                >
                  {localeText('COMMON.BTN_SUBMIT')}
                </Button>
              </div>
            </Mobile>
          </div>
        </Spin>
      </Modal>
    );
  }
}

export function showCompanySwitchModal() {
  store.toggleCompanySwitchModal(true);
}

export function hideCompanySwitchModal() {
  store.toggleCompanySwitchModal(false);
}

export default CompanySwitchList;
